import { render } from "./BtmBar.vue?vue&type=template&id=872973bc"
import script from "./BtmBar.vue?vue&type=script&lang=js"
export * from "./BtmBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__